/**
 * Created by vaibhav on 31/3/18
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux"
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Carousel } from 'react-responsive-carousel';
import './style.css';
import Img from "gatsby-image";
import remark from 'remark'
import recommended from 'remark-preset-lint-recommended'
import remarkHtml from 'remark-html'
import * as actions from '../../actions/modal'
import * as actPortfolio from '../../actions/portfolio';
import windowSize from 'react-window-size';

//let _w = [6, 6, 4, 4, 4, 6, 6, 4, 4, 4, 4, 6, 6, 4, 4, 4,6, 6, 4, 4, 4,6, 6, 4, 4, 4];//set in props
//let _w = [4,4,4,3,3,3,3,4,4,4,3,3,3,3,4,4,4,3,3,3,3,4,4,4,3,3,3,3,4,4,4,3,3,3,3]

const breakpoint = {
    mobile: 727,
    ipadV: 768,
    ipadH: 1024,
    desktop:1200,
    large:1400
};


class PortfolioLink extends Component {
  constructor (props) {
    super(props);
    this.state = {
      screenWidth: '',
      screenHeight: ''
    };
    this._openWithId =   this._openWithId.bind(this);
    this.handleWindowSizeChange_1 = this.handleWindowSizeChange_1.bind(this);

  };

  _openWithId(id,index) {
    //remove scroll of the body, to prevent scrolling - this is a bug of the Modal component.
    document.documentElement.style.overflowY = 'hidden';



    //send to the store, the portfolio id value
    if(this.state.screenWidth < breakpoint.mobile) {
      // if the thumbs are for different project we open at first position
      this.props.openWithId(id, 0);

    }else{
      // Gallery when the thumbs feature the same project, we open a a certain position.
      this.props.openWithId(id, index);
    }

  }


  handleWindowSizeChange_1 = () => {
    this.setState({ screenWidth: window.innerWidth, screenHeight:window.innerHeight });
  };


  componentWillMount(){
    //this.setState({screenWidth: window.innerWidth });
    //console.log('this.props.screenWidth' + this.props.windowWidth);
  }

  componentDidMount() {
  window.addEventListener('resize', this.handleWindowSizeChange_1);
  //this.handleWindowSizeChange_1();
}

// make sure to remove the listener
// when the component is not mounted anymore
componentWillUnmount() {
  window.removeEventListener('resize', this.handleWindowSizeChange_1);
}




    render() {

        return (
        <a className="cnt-item" href={"#/" + this.props.slug} onClick={() => this._openWithId(this.props.slug,this.props.index)}>
        {this.props.label}
        </a>
        );






    }
  }
  PortfolioLink.propTypes = {
      slug: PropTypes.string.isRequired,
      index: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      screenWidth: PropTypes.number,
      screenHeight: PropTypes.number
  };



  const mapStateToProps = ({ modalVisible, openWithId, close, lang, screenWidth, screenHeight }) => {
    return { modalVisible, openWithId, close, lang, screenWidth, screenHeight }
  }

  const mapDispatchToProps = dispatch => {
    return {
      openWithId: (v,i) => dispatch(actions.open_with_id(v,i)),
      close: () => dispatch(actions.close()),
     }
  }

  const ConnectedPortfolioLink = connect(mapStateToProps, mapDispatchToProps)(PortfolioLink)

  export default ConnectedPortfolioLink



// WEBPACK FOOTER //
// ./src/components/ConnectedGridPortfolio/ConnectedPortfolioLink.js